module.exports = __webpack_public_path__ + "media/images/bnr_referral_s_sp-a237efe1268f05c1718005120f3c424f.jpg";